import { isClient } from './device-utils';
import { IPost, IPinnedPost } from '../components';

interface IGetMostRecentPostIdProps {
  posts?: Array<IPost> | undefined;
  pinnedPosts?: Array<IPinnedPost> | undefined;
}

export const getMostRecentPostId = ({ posts = [], pinnedPosts = [] }: IGetMostRecentPostIdProps): string | null => {
  const allPosts = [...posts, ...pinnedPosts];
  if (allPosts.length === 0) {
    return null;
  }

  allPosts.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
  return allPosts[0].postId;
};

// Utility function to strip HTML tags
export const stripHtmlTags = (html: string): string => {
  if (typeof document === 'undefined') {
    return html.replace(/<\/?[^>]+(>|$)/g, '');
  }
  const div = document?.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

const getPageNumber = (index: number, postsPerPage: number): number => Math.floor((index + 1) / postsPerPage) + 1;

const shouldPostBeObserved = (index: number, postsPerPage: number) =>
  isClient() ? (index + 1) % postsPerPage === 0 : false;

export const mapPostsPerPage = ({
  posts,
  postsPerPage,
  postsVisible,
}: {
  posts: IPost[];
  postsPerPage: number;
  postsVisible: number;
}): IPost[] =>
  posts.map((post: IPost, index: number) => ({
    ...post,
    isHidden: index >= postsVisible,
    isObserved: shouldPostBeObserved(index, postsPerPage),
    pageNumber: getPageNumber(index, postsPerPage),
  }));
